/**
 * ehr#636 (reopened 10-25) - the Linked chart picker listed only 8 clients. It asked for
 * `limit=9`, dropped the chart it is on and cut the rest, with no way to see more: a
 * practice with 21 clients saw 8 of them unless the right letters were typed. It now asks
 * the server for a page of 25 (the server searches every client and leaves this chart out,
 * so the total is right), and a Show more row fetches the next page by cursor.
 */

/** Clients per page in the picker. */
export const PICK_PAGE = 25;

/** GET /contacts query for one page of the picker. */
export function pickQuery(text: string, excludeId: string, cursor?: string | null): string {
  const p = new URLSearchParams({ category: 'client', limit: String(PICK_PAGE) });
  const q = text.trim();
  if (q) p.set('search', q);
  if (excludeId) p.set('exclude', excludeId);
  if (cursor) p.set('cursor', cursor);
  return `/contacts?${p.toString()}`;
}

/** Appends a page, dropping ids already shown (and the chart itself, if the server sent it). */
export function mergeHits<T extends { id: string }>(prev: T[], page: T[], excludeId: string): T[] {
  const seen = new Set(prev.map((h) => h.id));
  return [...prev, ...page.filter((h) => h.id !== excludeId && !seen.has(h.id))];
}

/** The footer line: how many of how many, and how to narrow. */
export function pickCountLine(shown: number, total: number | null, searching: boolean): string {
  if (total === null || shown === 0) return '';
  const noun = total === 1 ? 'client' : 'clients';
  if (shown >= total)
    return searching
      ? `${total} ${noun} ${total === 1 ? 'matches' : 'match'}`
      : `All ${total} ${noun}`;
  return `Showing ${shown} of ${total} ${noun}${searching ? '' : '. Type a name to narrow'}`;
}
